export default __webpack_public_path__ + "static/media/img-flip-v.6f5f2fc0.svg";